import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';

import { CREATE_QUIZ_GAME, CREATE_QUIZ_GAME_SUCCESS, CREATE_QUIZ_GAME_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* createQuizGame({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/create-quiz-game-request`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_QUIZ_GAME_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_QUIZ_GAME_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_QUIZ_GAME_ERROR, payload: error });
  }
}

export function* watchCreateQuizGame() {
  yield takeEvery(CREATE_QUIZ_GAME, createQuizGame);
}

function* createQuizGameSaga() {
  yield all([fork(watchCreateQuizGame)]);
}

export default createQuizGameSaga;
